import { ZomentumEntities } from "../../common";
import { RecentActivityFeedType } from "../RecentActivityFeed";
import { ClientContact, Client } from "../../Clients";
import { Document } from "../../Documents";
import { Opportunity } from "../../Opportunity";
import { SalesActivity } from "../../Others/SalesActivity";
import { Product } from "../../Products";
import { UserData } from "../../Users";
import { MarketplaceProduct } from "../../Marketplace/Product";
import { VendorPartner } from "../../Vendor/Partner";
import { VendorResource } from "../../Vendor/Resources";
import { VendorOpportunity } from "../../Vendor/Opportunity";
import { VendorClient } from "../../Vendor/Clients";
import { Supplier } from "../../Settings";
import { SKUProduct } from "../../Vendor/SKU";
import { VendorUserData } from "../../Vendor/User";
import { MyVendor } from "../../Marketplace";
import { ChildEntityHydrationParams } from "../../Utils";

export enum GlobalSearchEntityType {
	Client = ZomentumEntities.Client,
	Document = ZomentumEntities.Document,
	ClientContact = ZomentumEntities.ClientContact,
	Product = ZomentumEntities.Product,
	Opportunity = ZomentumEntities.Opportunity,
	SalesActivity = ZomentumEntities.SalesActivity,
	Supplier = ZomentumEntities.Supplier,
	Task = ZomentumEntities.SalesTask,
	Meeting = ZomentumEntities.SalesMeeting,
	LogEmail = ZomentumEntities.SalesLogEmail,
	LogCall = ZomentumEntities.SalesLogCall,
	User = ZomentumEntities.User,
	VendorCompany = ZomentumEntities.VendorCompany,
	VendorResource = ZomentumEntities.VendorResource,
	MarketplaceListing = ZomentumEntities.MarketplaceListing,
	Comment = ZomentumEntities.Comment,
	MarketplaceSKU = ZomentumEntities.MarketplaceSKU,
	VendorTemplates = ZomentumEntities.VendorTemplate,
	VendorClient = ZomentumEntities.VendorClient,
	VendorOpportunity = ZomentumEntities.VendorOpportunity,
	VendorPartner = ZomentumEntities.VendorPartner,
	VendorUser = ZomentumEntities.VendorUser,
	VendorCompanies = ZomentumEntities.VendorCompanies
}

export interface GlobalSearchEntityObj {
	entity_type: GlobalSearchEntityType;
	obj:
		| Client
		| ClientContact
		| Document
		| Product
		| Opportunity
		| SalesActivity
		| UserData
		| Supplier
		| VendorPartner
		| VendorUserData
		| VendorResource
		| VendorOpportunity
		| MarketplaceProduct
		| VendorClient
		| SKUProduct
		| MyVendor;
}

export interface GlobalSearchResponse {
	data: GlobalSearchEntityObj[];
	next?: string;
}

export class GlobalSearchRequest {
	keywords: string;
	includedEntities: GlobalSearchEntityType[] | RecentActivityFeedType[];
	limit: number;
	nextCursor: string | null;
	useAtlasSearch?: boolean;
	includeChildEntities?: ChildEntityHydrationParams[];
	constructor(
		keywords: string,
		includedEntities: GlobalSearchEntityType[] | RecentActivityFeedType[],
		limit: number,
		nextCursor: string | null,
		useAtlasSearch?: boolean,
		includeChildEntities?: ChildEntityHydrationParams[]
	) {
		this.keywords = keywords;
		this.includedEntities = includedEntities;
		this.limit = limit;
		this.nextCursor = nextCursor;
		this.useAtlasSearch = useAtlasSearch;
		this.includeChildEntities = includeChildEntities;
	}
}
